import { render, staticRenderFns } from "./ligature_echo.vue?vue&type=template&id=54c7c906&scoped=true"
import script from "./ligature_echo.vue?vue&type=script&lang=js"
export * from "./ligature_echo.vue?vue&type=script&lang=js"
import style0 from "./ligature_echo.vue?vue&type=style&index=0&id=54c7c906&prod&scoped=true&lang=scss"
import style1 from "./ligature_echo.vue?vue&type=style&index=1&id=54c7c906&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54c7c906",
  null
  
)

export default component.exports